// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc8b316d","239":"c43224b4","455":"3c983fb2"}[chunkId] + ".chunk.js";
};